import _convertToPlainText from "./convertToPlainText.js";
const convertToPlainText = _convertToPlainText;
export default (function getWordCount(html) {
  return convertToPlainText(html, " ").split(" ").filter(word => {
    return word;
  }).length;
});